import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import './Cidades.css';

import API_BASE_URL from '../../../../config/api';

const Cidades = () => {
  const [cidades, setCidades] = useState([]);
  const [ufs, setUfs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    cidade: '',
    uf: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);

  const carregarUfs = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/uf`);
      if (!response.ok) {
        throw new Error('Erro ao buscar UFs');
      }
      const data = await response.json();
      setUfs(data);
    } catch (error) {
      console.error('Erro ao carregar UFs:', error);
      alert('Erro ao carregar UFs. Verifique a conexão com o servidor.');
    }
  };

  const carregarCidades = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/cidades`);
      if (!response.ok) {
        throw new Error('Erro ao buscar cidades');
      }
      const data = await response.json();
      const formatadas = data.map((item) => ({
        id: item.id_cidade,
        cidade: item.nome_cidade,
        uf: item.nome_uf,
        ativo: item.ativo
      }));
      setCidades(formatadas);
    } catch (error) {
      console.error('Erro ao carregar cidades:', error);
      alert('Erro ao carregar cidades. Verifique a conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarUfs();
    carregarCidades();
  }, []);

  const filteredCidades = cidades.filter((cidade) =>
    cidade.cidade.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        nome_cidade: formData.cidade,
        nome_uf: formData.uf,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(`${API_BASE_URL}/cidades/${editingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar cidade');
        }

        const atualizado = await response.json();

        setCidades(
          cidades.map((cidade) =>
            cidade.id === editingId
              ? {
                  id: atualizado.id_cidade,
                  cidade: atualizado.nome_cidade,
                  uf: atualizado.nome_uf,
                  ativo: atualizado.ativo
                }
              : cidade
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/cidades`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar cidade');
        }

        const criada = await response.json();

        setCidades([
          ...cidades,
          {
            id: criada.id_cidade,
            cidade: criada.nome_cidade,
            uf: criada.nome_uf,
            ativo: criada.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar cidade:', error);
      alert('Erro ao salvar cidade. Verifique os dados e tente novamente.');
    }
  };

  const handleEdit = (cidade) => {
    setFormData({
      cidade: cidade.cidade,
      uf: cidade.uf,
      ativo: cidade.ativo
    });
    setEditingId(cidade.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta cidade?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/cidades/${id}`, {
          method: 'DELETE'
        });

        if (!response.ok && response.status !== 204) {
          throw new Error('Erro ao excluir cidade');
        }

        setCidades(cidades.filter((cidade) => cidade.id !== id));
      } catch (error) {
        console.error('Erro ao excluir cidade:', error);
        alert('Erro ao excluir cidade. Tente novamente.');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      cidade: '',
      uf: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const cidadeSelecionada = cidades.find((c) => c.id === id);
    if (!cidadeSelecionada) {
      return;
    }

    const novoAtivo = !cidadeSelecionada.ativo;

    try {
      const response = await fetch(`${API_BASE_URL}/cidades/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nome_cidade: cidadeSelecionada.cidade,
          nome_uf: cidadeSelecionada.uf,
          ativo: novoAtivo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da cidade');
      }

      setCidades(
        cidades.map((cidade) =>
          cidade.id === id ? { ...cidade, ativo: novoAtivo } : cidade
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status da cidade:', error);
      alert('Erro ao atualizar status da cidade. Tente novamente.');
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Cidades</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Cidade
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Cidade' : 'Cadastrar Cidade'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="cidade">Nome da Cidade *</label>
              <input
                type="text"
                id="cidade"
                value={formData.cidade}
                onChange={(e) => setFormData({...formData, cidade: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o nome da cidade"
              />
            </div>

            <div className="form-group">
              <label htmlFor="uf">UF *</label>
              <select
                id="uf"
                value={formData.uf}
                onChange={(e) => setFormData({...formData, uf: e.target.value})}
                required
              >
                <option value="">Selecione...</option>
                {ufs.map((uf) => (
                  <option key={uf.id_uf} value={uf.ds_uf}>
                    {uf.ds_uf} - {uf.ds_uf_nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar cidades..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading ? 'Carregando cidades...' : `${filteredCidades.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table cidades-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Cidade</th>
                  <th className="col-nome">UF</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredCidades.map(cidade => (
                  <tr key={cidade.id}>
                    <td>{cidade.id}</td>
                    <td>{cidade.cidade}</td>
                    <td>{cidade.uf}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={cidade.ativo}
                          onChange={() => handleToggleStatus(cidade.id)}
                          id={`toggle-${cidade.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(cidade)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(cidade.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cidades;
